import moment from "moment";

export const tabs = [
  { title: "Pre-defined Tasks Config", value: "1" },
  { title: "Tasks Assignment", value: "2" },
  { title: "My Tasks", value: "3"}
];

export const tableData = [
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: false,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
];
